import React, {useState, useEffect, Fragment} from 'react';
import useWindowDimensions from '../../utils/useWindowDimensions';
import classes from './ContentDetails.module.scss';
import Button from '../UI/Button/Button';
import GooglePay from '../GooglePay/GooglePay';
import axios from '../../axios-instance';
import AppleWallet from '../../images/Add_to_Apple_Wallet_Button.png';
import ResponsiveDialog from '../UI/ResponsiveDialog/ResponsiveDialog';
import Scratcher from '../Scratcher/Scratcher';
import OfferDetails from './OfferDetails/OfferDetails';
// import Loader from './../UI/Loader/Loader';
import AgeGate from './../AgeGate/AgeGate';
import { useSelector } from 'react-redux';
import QrReader from "react-web-qr-reader";
import backgroundImage from './../../images/takis-purple-background.png';
import socialYoutube from './../../images/social-media-YouTube.png';
import socialInstagram from './../../images/social-media-Instagram.png';
import socialTiktok from './../../images/social-media-tiktok.png';
import ReCAPTCHA from "react-google-recaptcha";
import moment from 'moment';
import { withCookies, useCookies } from 'react-cookie';

const recaptchaRef = React.createRef();

let styles = {
    dateColor: {
        color: '#22A033'
    }
}

const ContentDetails = props => {
    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8DPLTLN']);

    const { scratcherOverlayImage } = props;
    const { height, width } = useWindowDimensions();
    const [
        // showLoading
        ,setShowLoading] = useState(true);
    const [showTerms, setShowTerms] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [downloadLink, setDownloadLink] = useState('');
    const [action, setAction] = useState('');
    const [imageError, setImageError] = useState(false)
    const [showOfferDetails, setShowOfferDetails] = useState(false);
    const [hasTimer, setHasTimer] = useState(false);
    const [limitSeconds, setLimitSeconds] = useState(0);
    const [hideAt, setHideAt] = useState(0);
    const [running, setRunning] = useState(false);
    const [expDate, setExpDate] = useState(0);
    const [expired, setExpired] = useState(null);
    const [distance, setDistance] = useState(0);
    const [showAgeGate, setShowAgeGate] = useState(false);
    const [showActionButtons, setShowActionButtons] = useState(true);
    const [autoAccept, setAutoAccept] = useState(false);
    const [qrCodeScannerBtn, setQrCodeScannerBtn] = useState(false);
    const [displayQrCodeScannerBtn, setDisplayQrCodeScannerBtn] = useState(false);
    const [displayQrCodeScanner, setDisplayQrCodeScanner] = useState(false);
    const [displayContentComp, setDisplayContentComp] = useState(true)
    const [displaySubmissionConfirmation, setDisplaySubmissionConfirmation] = useState(false)
    const [recaptchaResponse, setRecaptchaResponse] = useState(null);
    const [validRecaptcha, setValidRecaptcha] = useState(false);
    const [recaptchaError, setRecaptchaError] = useState(null);
    const [formValidationError, setFormValidationError] = useState(null);
    const [displayRegistrationError, setDisplayRegistrationError] = useState(false);
    const [displayWhiteContainer, setDisplayWhiteContainer] = useState(false);

    const content = useSelector((state) => state.content);
    const device = useSelector((state) => state.device);

    const getWindowDimensions = () => {
        let div = document.getElementById('responsiveContentContainer');    
        if (div) {
            let w = div.offsetWidth;
            let h = div.offsetHeight
            return {
                w,
                h
            };
        }
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    let attachedClasses = [classes.ContentPreview, classes.Close];

    let actionClasses = [classes.Actions];

    const updateTerms = (bool) =>  {
        setShowTerms(bool)
    }

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if(content?.content?.age_gate_enabled) {
            setShowAgeGate(true);
        } 
        
        // Check tags
        for(const element of content?.content?.tags) {                
            if(element.name === 'no-action-buttons') {
                setShowActionButtons(false)
            }
            if(element.name === 'auto-save') {
                setAutoAccept(true);
            }
            if(element.name === 'request-location' && process.env.REACT_APP_LOCATION_ENABLED_REDIRECT_SLUG !== '') {
                if(cookies.A8DPLTLN) {
                    window.open('/?sl=' + process.env.REACT_APP_LOCATION_ENABLED_REDIRECT_SLUG , '_self');
                    return;
                } else {
                    setTimeout(() => {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                setCookie('A8DPLTLN', position.coords.latitude+','+position.coords.longitude, {
                                    maxAge: 300,
                                    path: '/',
                                    sameSite: true,
                                });
                                window.open('/?sl=' + process.env.REACT_APP_LOCATION_ENABLED_REDIRECT_SLUG , '_self');
                            },
                            (err) => {
                                console.log(err);
                            }
                        );
                    }, 2000)
                }
            }
        }

        setHasTimer(content?.content?.redemption?.timer?.enabled ?? false);
        setLimitSeconds(content?.content?.redemption?.timer?.limit ?? 0);
        setHideAt(Number(content?.content?.redemption?.status?.hide_at) * 1000 ?? 0);
    }, [content]);

    useEffect(()=> {
        let countInterval;
        if (running) {
            const countDownDate = new Date(expDate).getTime();
            countInterval = setInterval(() => {
                const now = new Date().getTime();
                const distance = countDownDate - now;
                setDistance(distance)
                if (distance < 0) {
                    setExpired(true);
                    clearInterval(countInterval);
                } else {
                    setExpired(false)
                }
            }, 1000);
            return () =>  {
                setRunning(false);
                setExpDate(0)
                clearInterval(countInterval);
            }
        } else {
            setRunning(false);
            setExpDate(0)
            clearInterval(countInterval);
        }
    }, [expDate, running])

    const createMarkup = () => {
        return {__html: content?.content?.description};
    }

    useEffect(() => {
        updateTerms(content?.hasTerms)
    }, [content?.hasTerms]) 

    useEffect(() => {
        updatePass(content?.androidPass)
    }, [content?.androidPass]) 

    useEffect(() => {
        if (content?.showDownload) {
            let urlArr = new URL(content?.buyOnline).search.split('&');
            let str = urlArr[0].split('?action=').join('')
            setAction(str.charAt(0).toUpperCase() + str.slice(1))
            if (device?.deviceDetails?.isMobile) {
                device?.deviceDetails?.isIphone ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')));
            } else {
                device?.deviceDetails?.os_name === "Mac OS" ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')))
            }
        }
    }, [content?.showDownload, content?.buyOnline, device?.deviceDetails]) 

    useEffect(() => {
        // If the auto-save tag is added to the content, an "accept" impression is added immediately so that the prize can be reserved. 
        if(autoAccept) {
            updateStatus(2);
        }        

        if (props.scratcher === true || props.scratcher === null) {
            toggleLoading(true);
        } else {
            // Delay the update by 2 seconds to avoid collision with catch impression tracking
            setTimeout(()=>{
                updateStatus(1);
            }, 2000);
            //toggleLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.scratcher, autoAccept]) 

    useEffect(()=>{
        content.content.buttons.forEach((value, key) => {
            if(value.key==='open_qr_scanner_btn') {
                setDisplayQrCodeScannerBtn(true)
                setQrCodeScannerBtn(value)
                console.log('Display QrCode scanner btn')
            }            
        });        
    }, [])

    const updatePass = (bool) =>{
        setShowPass(true)
    }

    const toggleLoading = (bool) => {
        setShowLoading(bool);
    }

    const onTerms = () => {
        setShowModal(!showModal)
    }
    
    // eslint-disable-next-line no-undef
    const updateStatus = async status => {
        try {
          const uri = `/device/${device?.deviceDetails?.uuid}/content/${content?.content?.id}?status=${status}`;
          await axios.put(
            uri,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }
            }
          ).then((res) => {
            if (res && res.status === 200) {
                if (res.data && res.data.message) {
                //   console.log('STATUS: ', status + ' ', res.data.message);
                }
              }
          });
        } catch (err) {
            console.error('Error: ', err);
        }
    };    

    const postEvent = async(event) => {

        try {
          await axios.post(`/event`, event, {
            headers: {
              'x-device-uuid': `${device?.deviceDetails?.uuid}`,
            }
          }).then((res) => {
            if (res && res.data) {
                console.log('Event tracked', res.data);
              }
          });

        } catch(err) {
          console.error('Error: ', err);
        }
    }

    const getAppleWalletPasskit = async () => {
        let root = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_ROOT_DEV : process.env.REACT_APP_ACTV8_API_ROOT_PROD;
        let key = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_KEY_DEV : process.env.REACT_APP_ACTV8_API_KEY_PROD;

        try {
          const uri = `${root}/device/${device?.deviceDetails?.id}/content/${content?.content?.id}/applepass`;
          fetch(uri, {
            headers: {
              'x-api-key': `${key}`,
              'x-api-version': `4.4`,
              'Accept': 'application/vnd.apple.pkpass',
              'x-device-uuid': `${device?.deviceDetails?.uuid}`
            }
          }).then(response => {            
            updateStatus(2);
            response.blob().then(blob => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.href = url;
              a.download = 'pass.pkpass';
              a.click();
            });
          });
        } catch (err) {
          console.error('Error: ', err);
        }
    };

    const createAppleWalletPasskit = async () => {
        try {
          const uri = `/device/${device?.deviceDetails?.id}/content/${content?.id}/applepass`;
          const res = await axios.post(
            uri,
            {
                forward_params:props.forwardParams, 
                latitude : device?.deviceDetails?.location?.lat,
                longitude : device?.deviceDetails?.location?.lon
            },
            {
              headers: {
                'Accept': 'application/vnd.apple.pkpass',
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }
            }
          );
          if (res && res.data) {
            getAppleWalletPasskit();
          }
        } catch (err) {
          console.error(err);
        }
    };

    const onBuyNow = () => {
        let url = content?.content?.redemption?.url ?? '';
        // Appends forward params (i.e. macros) based on env setting 
        if(url !== '' && process.env.REACT_APP_FORWARD_PARAMS === 'true') {
            url += url.indexOf('?') > -1 ? '&' : '?';
            url += props.forwardParams;
        }
        window.open(url,'_blank');
        updateStatus(5)
    }

    const onClickThrough1 = () => {
        let url = content?.clickThroughBtn1?.value ?? '';
        handleClickThrough(url);
    }

    const onClickThrough2 = () => {
        let url = content?.clickThroughBtn2?.value ?? '';
        handleClickThrough(url);
    }

    const handleClickThrough = (url, target = '_blank') => {
        const event = {
            category: "End-User Action",
            subcategory: "Content Button",
            action: "Click-Through",
            label: url,
        } 

        event.client_id = content?.content?.client_id ?? null;
        event.campaign_id = content?.content?.pivot?.campaign_id ?? null;
        event.trigger_id = content?.content?.pivot?.trigger_id ?? null;
        event.content_id = content?.content?.pivot?.content_id ?? null;

        updateStatus(8)
        postEvent(event);
        window.open(url, target);

    }

    const onDownloadApp = () => {
        window.open(downloadLink, "_blank")
    }
    const onImageError = () => {
        setImageError(true);
        toggleLoading(false);
    }
    const onViewOfferDetails = (type) => {
        setShowOfferDetails(true);
        if (type === 'instore' && !hasTimer) {
            updateStatus(4)
        }
    }
    const onCloseOfferDetails = () => {
        setShowOfferDetails(!showOfferDetails);
    }
    if (content?.content?.redemption?.method === 3) {
        actionClasses.push(classes.MoreBtnSpace)
    }
    let terms;

    if (props.open) {
        attachedClasses = [classes.ContentPreview, classes.Open];
    }
        
    terms = (
        <div className={classes.Terms} onClick={onTerms}>
            Terms & Conditions
        </div>
    )

    if (content?.endDate) {
        let date = content?.endDate.split(' ');
        styles = {
            dateColor: {
                color: props.date === 'Expired' ? '#A02222' : (date[0] === 'in' && Number(date[1]) <= 3 && date[2] === 'days') || date[2] === 'day' ? '#FFA000' : '#22A033'
            }
        }
    }
   
    const utcDateConverter = (datestring) => {
        const split = datestring.split(" ");
        return split[0] + "T" + split[1] + "Z"
    }

    const [showApplePass, setShowApplePass] = useState(false);
    const [showGooglePass, setShowGooglePass] = useState(false);

    useEffect(() => {
        if (showPass === true) {
            var winNav = window.navigator;
            let isIOSChrome = winNav.userAgent.match('CriOS');
            if (
                device?.deviceDetails?.isMobile &&
                device?.deviceDetails?.isIphone &&
                content?.applePass &&
                !isIOSChrome
            ) {
                setShowApplePass(true);
            } else {
                setShowGooglePass(true);
            }
        }
    }, [
        content,
        content?.applePass,
        device,
        device?.isIphone,
        device?.isMobile,
        showPass,
    ]);

    const handleAgeEntered = (isLegal) => {
        setShowAgeGate(!isLegal);
    }

    const urls = content?.content?.urls ? content?.content?.urls?.map((url) => 
        <Button 
            className={classes.Button} 
            style={url.style}
            href={url.url} 
            key={url.url}
            target={url.target?? '_self'}
            onClick={() => handleClickThrough(url.url, url.target?? '_self')}
            btnText={url.label}
            />
    ) : null;
    
    const urlActionButtons = (
    <div style={{paddingBottom: "20px", width: "90%", marginLeft: "auto", marginRight: "auto"}}>
        {urls?.length > 0 && urls} 
        {/* {content?.content?.url && 
            <Button         
                className={classes.Button} 
                href={content?.content?.url} 
                target="_blank"
                onClick={() => handleClickThrough(content?.content?.url)}
                btnText="Click Here"
            />
        } */}
    </div>
    )
  
  
    const qrCodeReader = 
        <div style={{width:"90%", marginLeft: "auto", marginRight: "auto"}}>
            <QrReader
                delay={500}
                style={{
                    width: "100%",
                    height: "auto"
                }}
                onError={(error) => {
                    console.log(error);
                }}
                onScan={(result) => {
                    if (result && result.data) {
                    // setResult(result);
                    console.log(result.data);
                    window.location.href = result.data;
                    }
                }}    
            />
                <Button         
                    className={classes.Button} 
                    onClick={() => {setDisplayQrCodeScanner(false); setDisplayContentComp(true)}}
                    btnText="Cancel"
                />
        </div>

    const genericActionButtons = (
        <div className={actionClasses.join(' ')}>
            {(content?.content?.redemption?.method === 2 ||
                content?.content?.redemption?.method === 3) && (
                <Button
                    onClick={() => onViewOfferDetails('instore')}
                    btnText={
                        content?.content?.type === 'prize'
                            ? 'Redeem Prize'
                            : content?.buyInStoreText
                    }
                    className={classes.Button}
                />
            )}
            {content?.buyOnline &&
            content?.buyOnline !== '' &&
            content?.type !== 'prize' &&
            !content?.showDownload &&
            !content?.clickThroughBtn1 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.content?.redemption &&
                        content?.content?.redemption !== null &&
                        content?.content?.redemption.url
                            ? content?.content?.redemption.url
                            : ''
                    }
                    target='_blank'
                    onClick={onBuyNow}
                    btnText={content?.buyNowText}></Button>
            ) : (
                ''
            )}

            {content?.clickThroughBtn1 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.clickThroughBtn1.value
                            ? content?.clickThroughBtn1.value
                            : ''
                    }
                    target='_blank'
                    onClick={onClickThrough1}
                    btnText={
                        content?.clickThroughBtn1.label
                            ? content?.clickThroughBtn1.label
                            : ''
                    }></Button>
            ) : (
                ''
            )}

            {content?.clickThroughBtn2 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.clickThroughBtn2.value
                            ? content?.clickThroughBtn2.value
                            : ''
                    }
                    target='_blank'
                    onClick={onClickThrough2}
                    btnText={
                        content?.clickThroughBtn2?.label
                            ? content?.clickThroughBtn2?.label
                            : ''
                    }></Button>
            ) : (
                ''
            )}

            {content?.showDownload && downloadLink && downloadLink !== '' ? (
                <Button
                    href={downloadLink}
                    target='_blank'
                    className={classes.Button}
                    btnText={action}
                    onClick={onDownloadApp}></Button>
            ) : (
                ''
            )}
            {displayQrCodeScannerBtn && 
                <Button
                className={classes.Button}
                btnText={qrCodeScannerBtn.label}
                onClick={() => {setDisplayQrCodeScanner(true); setDisplayContentComp(false)}}/>
            }
        </div>
    );

    const actionButtons = (
        <div>{content?.content?.type === 'url' || content?.content?.type === 'message' ? urlActionButtons : genericActionButtons}</div>
    )

    const offerComp = (
        <div
            className={classes.ContentContainer} style={{backgroundColor: "#FFF", height: windowDimensions?.h}}
            id={'responsiveContentContainer'}>
            <ResponsiveDialog open={showModal} onClose={() => onTerms()}>
                {content?.terms}
            </ResponsiveDialog>
            <ResponsiveDialog
                offerDetailsModal={true}
                open={showOfferDetails}
                onClose={() => onCloseOfferDetails()}>
                <OfferDetails
                    onUpdateStatus={updateStatus}
                    brand={content?.brand}
                    content={content?.content}
                    hasTimer={hasTimer}
                    hideAt={hideAt}
                    limitSeconds={limitSeconds}
                    onSetExpDate={(date) => setExpDate(date)}
                    distance={distance}
                    running={running}
                    onSetRunning={(bool) => setRunning(bool)}
                    expired={expired}
                    onClose={() => onCloseOfferDetails()}
                    onBuyNow={onBuyNow}
                />
            </ResponsiveDialog>
            <div>
                {(!content?.content.display_preferences || content?.content.display_preferences?.hero) &&
                    <section className={classes.HeroContainer}>
                        {imageError ? (
                            <div className={classes.FallbackHero}>
                                <div>Image Loading Error</div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={classes.HeroImage}>
                            {!imageError ? (
                                <img
                                    src={content?.hero}
                                    alt={content?.hero}
                                    onLoad={() => toggleLoading(false)}
                                    onError={onImageError}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                    </section>
                }
                {showAgeGate ? (
                    <Fragment>
                        <div
                            className={classes.ContentItems}
                            style={{
                                width: '312px',
                                height: '320px',
                                borderRadius: '12px',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)',
                                margin: '0 auto 15px auto',
                            }}>
                            <AgeGate onAgeEntered={handleAgeEntered} />
                        </div>
                    </Fragment>
                ) : (
                    <div className={classes.ContentItems}>
                        {(!content?.content.display_preferences || content?.content.display_preferences?.title) &&
                            <div className={classes.Title}>{content?.title}</div>
                        }
                        <div className={classes.SubContent}>
                            {(!content?.content.display_preferences || content?.content.display_preferences?.brand) &&
                                <div className={classes.Brand}>
                                    {content?.brand}
                                </div>
                            }
                            {(!content?.content.display_preferences || content?.content.display_preferences?.expiration) &&
                                <div
                                    style={styles.dateColor}
                                    className={classes.Date}>
                                    {content?.endDate !== 'Expired'
                                        ? 'Expires on '
                                        : ''}{' '}
                                    {content?.content.end_at && moment(utcDateConverter(content?.content.end_at)).format('MM/DD/YYYY')}
                                </div>
                            }
                            <div className={classes.PayBtn}>
                                <div className={classes.BtnCol}>
                                    {showApplePass === true && content?.content?.id && (
                                        <img
                                            src={AppleWallet}
                                            alt='Add to Apple Wallet'
                                            className={classes.WalletButton}
                                            onClick={() =>
                                                createAppleWalletPasskit()
                                            }
                                            style={{
                                                width: "280px",
                                                height: "44px"
                                            }}
                                        />
                                    )}
                                    {showGooglePass && content?.jwt && content?.jwt !== '' && (
                                        <GooglePay
                                            onSaveToWallet={() =>
                                                updateStatus(2)
                                            }
                                            jwt={content?.jwt}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {(!content?.content.display_preferences || content?.content.display_preferences?.description) &&
                            <div className={classes.Description}>
                                <div dangerouslySetInnerHTML={createMarkup()}></div>
                                {(content?.content.content_term_id && (!content?.content.display_preferences || content?.content.display_preferences?.termsAndConditions)) &&
                                    terms
                                }
                            </div>
                        }   
                    </div>
                )}
            </div>
            {(!content?.content.display_preferences || content.content.display_preferences?.actionButtons) &&            
                (!showAgeGate && showActionButtons && actionButtons)
            }

        </div>
        
    );

    const prizeComp = offerComp;


    const urlComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{width: "100%", height: "100%"}}>
        <ResponsiveDialog
            open={showModal}
            onClose={() => onTerms()}>
                {content?.terms}
        </ResponsiveDialog>
        <div>
            {(!content?.content.display_preferences || content?.content.display_preferences?.hero) &&
                <section className={classes.HeroContainer} style={{marginBottom: "40px"}}>
                    {imageError ? (
                        <div className={classes.FallbackHero}>
                            <div>Image Loading Error</div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.HeroImage}>
                        {!imageError ? (
                            <img
                                src={content?.hero}
                                alt={content?.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </section>
            }
            { showAgeGate ? 
                <Fragment>
                    <div className={classes.ContentItems} style={{width: '312px', height : '320px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)', margin: '0 auto 15px auto'}}>
                        <AgeGate onAgeEntered={handleAgeEntered}/>
                    </div> 
                </Fragment> 
                :   <div className={classes.ContentItems}>
                        {/* <div>
                            <img src={TakisLogo} style={{width: "100%", marginTop: "20px", marginBottom: "40px"}} alt="Takis Logo"/>
                        </div> */}
                        {(!content?.content.display_preferences || content?.content.display_preferences?.title) &&
                            <div className={classes.Title} style={{
                                fontFamily: "Lilita One",
                                textShadow: "0px 2px 4px rgba(0, 0, 0, 0.50)",
                                fontSize: "30px",
                                color: "white",
                                lineHeight: "150%",
                                fontWeight: "400"
                            }}>{content?.title}</div>
                        }
                        <div className={classes.SubContent}>
                            {(!content?.content.display_preferences || content?.content.display_preferences?.brand) &&
                                <div className={classes.Brand}>
                                    {content?.brand}
                                </div>
                            }
                            {(!content?.content.display_preferences || content?.content.display_preferences?.expiration) &&
                                <div
                                    style={styles.dateColor}
                                    className={classes.Date}>
                                    {content?.endDate !== 'Expired'
                                        ? 'Expires'
                                        : ''}{' '}
                                    {content?.endDate}
                                </div>
                            }
                        </div>
                        {(!content?.content.display_preferences || content?.content.display_preferences?.description) &&
                            <div className={classes.Description} style={{
                                color: "white",
                                fontSize: "16px",
                                lineHeight: "150%",
                                fontWeight: "500",
                                fontFamily: "Inter",
                                textAlign: "center",
                                height: "auto",
                                paddingBottom: "0px"
                            }}>
                                <div dangerouslySetInnerHTML={createMarkup()}></div>
                                {(content?.content.content_term_id && (!content?.content.display_preferences || content?.content.display_preferences?.termsAndConditions)) &&
                                    terms
                                }
                            </div>
                        }
                    </div>

            }

        </div>
        
        { !showAgeGate && showActionButtons && actionButtons}
    </div>)


    const messageComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'}>
        <ResponsiveDialog
            open={showModal}
            onClose={() => onTerms()}>
                {content?.terms}
        </ResponsiveDialog>
        <div>
            <section className={classes.HeroContainer}>
                { imageError ? <div className={classes.FallbackHero}><div>Image Loading Error</div></div> : ''}
                <div className={classes.HeroImage}>
                    { !imageError ?
                        <img
                            src={content?.hero}
                            alt={content?.hero}
                            onLoad={() => toggleLoading(false)}
                            onError={onImageError}/> : ''
                    }                            
                </div>
            </section>
            {content?.content?.images?.in_body?.url ? 
                <section className={classes.InBodyContainer}>
                    <div className={classes.InBodyImage}>
                        <img
                            src={content?.content?.images.in_body.url}
                            alt={content?.content?.images.in_body.url}/> 
                    </div>
                </section> : ''}            
            { showAgeGate ? 
                <Fragment>
                    <div className={classes.ContentItems} style={{width: '312px', height : '320px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)', margin: '0 auto 15px auto'}}>
                        <AgeGate onAgeEntered={handleAgeEntered}/>
                    </div> 
                </Fragment> 
                : ''
            }

        </div>
        
        { !showAgeGate && showActionButtons && actionButtons}
    </div>)


    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [emailAddress, setEmailAddress] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);

    const handleSubmit = async () => {
        const payload = {
            first_name : firstName,
            last_name : lastName,
            email : emailAddress,
            phone_number : phoneNumber,
            source_id : content?.content?.id,
            source_type : 'url',
            restriction : {
                enabled : true,
                period : 'daily'
            }
        }

        await axios.post(`/user/subscribe`, payload, {
            headers: {
            'x-device-uuid': `${device?.deviceDetails?.uuid}`,
            }
        }).then((res) => {
            if (res && res.data) {
                if(res.status === 201) {
                    setDisplaySubmissionConfirmation(true)
                    postEvent({
                        category: "end-user-action",
                        subcategory: "sweepstakes",
                        action: "submit-contact-information",
                        label: 'Daily Entry',
                        content_id : content?.content?.pivot?.content_id,
                        client_id : content?.content?.client_id,
                        campaign_id : content?.content?.pivot?.campaign_id,
                        trigger_id : content?.content?.pivot?.trigger_id
                    });                    
                } else if (res.status === 200){
                    // Redirect to already entered
                    window.open('/?sl=' + process.env.REACT_APP_SWEEPSTAKES_ALREADY_ENTERED, '_self');
                    console.log('redirect to already entered');
                }        

            }

        }).catch((res) => {
            console.log('There was an error')
        });
  
    

    }

    const submissionFormComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{width: "100%", height: windowDimensions?.h}}>
        <ResponsiveDialog
            open={showModal}
            onClose={() => onTerms()}>
                {content?.terms}
        </ResponsiveDialog>
        <div>
            {(!content?.content.display_preferences || content?.content.display_preferences?.hero) &&
                <section className={classes.HeroContainer}>
                    {imageError ? (
                        <div className={classes.FallbackHero}>
                            <div>Image Loading Error</div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.HeroImage} style={{paddingTop: "20px"}}>
                        {!imageError ? (
                            <img
                                src={content?.hero}
                                alt={content?.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </section>
            }
            { showAgeGate ? 
                <Fragment>
                    <div className={classes.ContentItems} style={{width: '312px', height : '320px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)', margin: '0 auto 15px auto'}}>
                        <AgeGate onAgeEntered={handleAgeEntered}/>
                    </div> 
                </Fragment> 
                :   <div className={classes.ContentItems}>
                        {(!content?.content.display_preferences || content?.content.display_preferences?.title) &&
                            <div className={classes.Title} style={{
                                fontFamily: "Lilita One",
                                textShadow: "0px 2px 4px rgba(0, 0, 0, 0.50)",
                                fontSize: "30px",
                                color: "white",
                                lineHeight: "150%",
                                fontWeight: "400",
                                marginBottom: "30px"
                            }}>TAKIS x MAC & CHEESE<br/><span style={{fontSize: "50px"}}>SWEEPSTAKES</span></div>
                        }
                        <div className={classes.SubContent}>
                            {(!content?.content.display_preferences || content?.content.display_preferences?.brand) &&
                                <div className={classes.Brand}>
                                    {content?.brand}
                                </div>
                            }
                            {(!content?.content.display_preferences || content?.content.display_preferences?.expiration) &&
                                <div
                                    style={styles.dateColor}
                                    className={classes.Date}>
                                    {content?.endDate !== 'Expired'
                                        ? 'Expires'
                                        : ''}{' '}
                                    {content?.endDate}
                                </div>
                            }
                        </div>
                        <div style={{
                            width: "90%", 
                            height: "auto", 
                            marginLeft: "auto",
                            marginRight: "auto",
                            backgroundColor: "white", 
                            borderRadius: "10px",
                            display: "flex",
                            maxWidth: "480px",
                            padding: "20px",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            alignSelf: "stretch",
                            boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)"
                        }}>
                            
                        {(!content?.content.display_preferences || content?.content.display_preferences?.description) &&
                            <div className={classes.Description} style={{
                                color: "black",
                                fontSize: "16px",
                                lineHeight: "150%",
                                fontWeight: "500",
                                fontFamily: "Inter",
                                textAlign: "center",
                                height: "auto",
                                paddingBottom: "0px"
                            }}>
                                <div dangerouslySetInnerHTML={createMarkup()}></div>
                                {/* {(content?.content.content_term_id && (!content?.content.display_preferences || content?.content.display_preferences?.termsAndConditions)) &&
                                    terms
                                } */}
                            </div>
                        }
                            <form style={{width: '100%'}} onSubmit={(event) => {
                                event.preventDefault(); 
                                if(validRecaptcha){
                                    setRecaptchaError(null)
                                    // setDisplayRegistrationError(false)
                                    // setDisplaySubmitButton(false); 
                                    // setDisplayRegistrationLoader(true);
                                    // submitRegistration();
                                    handleSubmit()
                                } else {
                                    setRecaptchaError("You must verify you're not a robot!")}     
                            }}>
                                <input required type="text" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)}/>
                                <input required type="text" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} />
                                <input type="text" placeholder="Phone Number (Optional)" onChange={(e) => setPhoneNumber(e.target.value)} />
                                <input required type="text" placeholder="Email Address" onChange={(e) => setEmailAddress(e.target.value)} />
                                <p style={{color: "red", marginTop: "5px"}}>{formValidationError}</p>

                                <div style={{textAlign: 'left', paddingBottom: '10px', color: "#000", fontSize: "14px"}}>
                                    <div style={{marginRight: "10px", float: "left"}}>
                                        <input required type="checkbox" style={{height: "21px", width: "21px"}}/>
                                    </div>
                                    <div>
                                        I agree to the <a href="https://barcel-usa.com/barcel-privacy-notice">Privacy Policy</a>, <a href="https://barcel-usa.com/barcel-privacy-notice">Terms & Conditions</a>, and <a href="/Takis_Back_to_School_Sweepstakes_Game_Rules_072024.pdf">Sweepstakes Rules</a>
                                    </div>                            
                                </div>

                                <div style={{marginLeft: "auto", marginRight: "auto", padding: "0px", position: "relative", marginBottom: "10px", marginTop: "15px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                    <ReCAPTCHA                            
                                        ref={recaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        onChange={(response) => {setValidRecaptcha(true); setRecaptchaError(false); setRecaptchaResponse(response); }}
                                    />
                                </div>
                                {recaptchaError && <p style={{color: "red", textAlign: "center"}}>{recaptchaError}</p>}

                                {displayRegistrationError && <p style={{color: "red", width: "80%", marginLeft: "auto", marginRight: "auto"}}>There was an error processing your information. Please try again.</p>}
                                {/* {displayRegistrationLoader && <div style={{marginTop:'25px'}}><Loader displayLogo={false} /></div>} */}


                                {content?.content?.urls && content?.content?.urls[0] && 
                                    <Button 
                                        className={classes.Button} 
                                        style={content?.content?.urls[0]?.style}
                                        href={content?.content?.urls[0]?.url} 
                                        key={content?.content?.urls[0]?.url}
                                        target={content?.content?.urls[0]?.target?? '_self'}
                                        btnText={content?.content?.urls[0]?.label}
                                        useGradient={true}
                                    />
                                }
                            </form>
                        </div>
                    </div>

            }

        </div>
        

    </div>)    

    const socialButtons = <div>
        <div style={{marginTop: "20px", textAlign: "center", fontSize: "18px", fontStyle: "normal", fontWeight: "600", lineHeight: "150%", color: "#fff"}}>
            Follow Kraft on Social
            <div style={{paddingTop: "10px"}}>
                <img src={socialTiktok} alt="Twitter Icon" style={{width: "50px", paddingLeft: '7.5px', paddingRight: '7.5px'}} onClick={() => window.open('https://www.tiktok.com/@maccheesebykraft')}/>
                <img src={socialInstagram} alt="Instagram Icon" style={{width: "50px", paddingLeft: '7.5px', paddingRight: '7.5px'}} onClick={() => window.open('https://www.instagram.com/kraft_macandcheese/')}/>                            
            </div>
        </div>

        <div style={{marginTop: "20px", textAlign: "center", fontSize: "18px", fontStyle: "normal", fontWeight: "600", lineHeight: "150%", color: "#fff"}}>
            Follow Takis® on Social
            <div style={{paddingTop: "10px"}}>
                <img src={socialYoutube} alt="Youtube Icon" style={{width: "50px", paddingLeft: '7.5px', paddingRight: '7.5px'}} onClick={() => window.open('https://www.youtube.com/@TakisUSA')}/>
                <img src={socialTiktok} alt="TikTok Icon" style={{width: "50px", paddingLeft: '7.5px', paddingRight: '7.5px'}} onClick={() => window.open('https://www.tiktok.com/@takisusa')}/>
                <img src={socialInstagram} alt="Instagram Icon" style={{width: "50px", paddingLeft: '7.5px', paddingRight: '7.5px'}} onClick={() => window.open('https://www.instagram.com/takisusa/')}/>
            </div>
        </div>
    </div>

    const submissionConfirmationComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{width: "100%", height: windowDimensions?.h}}>
        <div>
            {(!content?.content.display_preferences || content?.content.display_preferences?.hero) &&
                <section className={classes.HeroContainer} style={{marginTop: "20px"}}>
                    {imageError ? (
                        <div className={classes.FallbackHero}>
                            <div>Image Loading Error</div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.HeroImage}>
                        {!imageError ? (
                            <img
                                src={content?.hero}
                                alt={content?.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </section>
            }
            { <div className={classes.ContentItems}>
                    {(!content?.content.display_preferences || content?.content.display_preferences?.title) &&
                        <div className={classes.Title} style={{
                            fontFamily: "Lilita One",
                            textShadow: "0px 2px 4px rgba(0, 0, 0, 0.50)",
                            fontSize: "30px",
                            color: "white",
                            lineHeight: "150%",
                            fontWeight: "400",
                            marginBottom: "30px"
                        }}>TAKIS x MAC & CHEESE<br/><span style={{fontSize: "50px"}}>SWEEPSTAKES</span></div>
                    }

                    <div style={{
                        width: "90%", 
                        height: "auto", 
                        marginLeft: "auto",
                        marginRight: "auto",
                        backgroundColor: "white", 
                        borderRadius: "10px",
                        display: "flex",
                        maxWidth: "480px",
                        padding: "20px",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        alignSelf: "stretch",
                        boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)"
                    }}>
                    
                    <div style={{
                        color: '#000',
                        textAlign: 'center',
                        fontFamily: 'Inter',
                        fontSize: '30px',
                        fontStyle: 'normal',
                        fontWeight: '800',
                        lineHeight: '150%'
                    }}>THANK YOU</div>

                    {(!content?.content.display_preferences || content?.content.display_preferences?.description) &&
                        <div className={classes.Description} style={{
                            color: "black",
                            fontSize: "16px",
                            lineHeight: "150%",
                            fontWeight: "500",
                            fontFamily: "Inter",
                            textAlign: "center",
                            height: "auto",
                            paddingBottom: "0px"
                        }}>
                            <p>We have received your submission! </p>
                            <p>If you are selected as a winner, we will contact you at the email provided.</p>
                        </div>
                    }

                    {content?.content?.url && content?.content?.url[0] && showActionButtons &&
                        <Button 
                            className={classes.Button} 
                            style={content?.content?.urls[0]?.style}
                            href={content?.content?.urls[0]?.url} 
                            key={content?.content?.urls[0]?.url}
                            target={content?.content?.urls[0]?.target?? '_self'}
                            onClick={() => window.open('?sl=' + process.env.REACT_APP_MAIN_MENU_SLUG, '_self')}
                            btnText={'BACK TO MENU'}
                            useGradient={true}                            
                        />
                    }
                    </div>

                    {socialButtons}
                </div>

            }

        </div>


    </div>) 

    const alreadyEnteredComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{width: "100%", height: windowDimensions?.h}}>
        <div>
            {(!content?.content.display_preferences || content?.content.display_preferences?.hero) &&
                <section className={classes.HeroContainer} style={{marginTop: "20px"}}>
                    {imageError ? (
                        <div className={classes.FallbackHero}>
                            <div>Image Loading Error</div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.HeroImage}>
                        {!imageError ? (
                            <img
                                src={content?.hero}
                                alt={content?.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </section>
            }
            { <div className={classes.ContentItems}>

                    <div style={{
                        width: "90%", 
                        height: "auto", 
                        marginLeft: "auto",
                        marginRight: "auto",
                        backgroundColor: "white", 
                        borderRadius: "10px",
                        display: "flex",
                        maxWidth: "480px",
                        padding: "20px",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        alignSelf: "stretch",
                        boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)"
                    }}>
                    
                    <div style={{
                        color: '#000',
                        textAlign: 'center',
                        fontFamily: 'Inter',
                        fontSize: '30px',
                        fontStyle: 'normal',
                        fontWeight: '800',
                        lineHeight: '150%'
                    }}>{content?.content.display_name}</div>

                    {(!content?.content.display_preferences || content?.content.display_preferences?.description) &&
                        <div className={classes.Description} style={{
                            color: "black",
                            fontSize: "16px",
                            lineHeight: "150%",
                            fontWeight: "500",
                            fontFamily: "Inter",
                            textAlign: "center",
                            height: "auto",
                            paddingTop: "20px",
                            paddingBottom: "30px"
                        }}>
                            <div dangerouslySetInnerHTML={createMarkup(content?.content?.description)}/>
                        </div>
                    }

                    {content?.content?.url && content?.content?.url[0] && showActionButtons &&
                        <Button 
                            className={classes.Button} 
                            style={content?.content?.urls[0]?.style}
                            href={content?.content?.urls[0]?.url} 
                            key={content?.content?.urls[0]?.url}
                            target={content?.content?.urls[0]?.target?? '_self'}
                            onClick={() => window.open(content?.content?.urls[0]?.url, '_self')}
                            btnText={content?.content?.urls[0]?.label}
                            useGradient={false}
                        />
                    }
                    </div>
                    {socialButtons}
                </div>

            }

        </div>


    </div>) 


    let contentComp = null;
    switch (content?.content?.type) {
        case 'offer': contentComp = offerComp; break;
        case 'url':
            if(content?.content?.name === 'TAKIS x MAC & CHEESE SWEEPSTAKES' || content?.content?.name === 'TAKIS x MAC & CHEESE SWEEPSTAKES - SOCIAL') {
                if(!displaySubmissionConfirmation) {
                    contentComp = submissionFormComp;    
                } else {
                    contentComp = submissionConfirmationComp;
                }
                
            } else if (content?.content?.name === 'ALREADY ENTERED'){
                contentComp = alreadyEnteredComp; 
            } else {
                contentComp = urlComp
            }

            break;
        case 'message': contentComp = messageComp; break;
        case 'prize': contentComp = prizeComp; break;
        default:
    }

    return (
        <div
            className={attachedClasses.join(' ')}
            style={{ width: displayQrCodeScanner ? '100%' : 'auto', backgroundImage: content?.content?.type === 'url' ? `url(${backgroundImage})` : 'none'}}>
            {/* {showLoading ? (
                <div style={{height: height, width: width, maxHeight: '736px', maxWidth: '414px', paddingTop: '60px'}} className={classes.ContentPreviewLoading}>
                    <Loader />
                </div> ) : ''
            } */}
            {props.scratcher ? (
                <Scratcher
                    onUpdateStatus={updateStatus}
                    onToggleLoading={toggleLoading}
                    overlay={scratcherOverlayImage}
                    height={height}
                    width={width}
                    isMobile={device?.deviceDetails?.isMobile}
                    windowDimensions={windowDimensions}>
                    <div style={{height: "auto"}}>
                        {displayQrCodeScanner && qrCodeReader}
                        {displayContentComp && contentComp}
                    </div>
                </Scratcher>
            ) : (

                <div style={{
                    // height: "auto",
                    position: 'relative',
                    width: width,
                    maxWidth: '430px',
                    height: '100%',
                    maxHeight: '932px',
                    top: 0
                }}>
                    {displayQrCodeScanner && qrCodeReader}
                    {displayContentComp && contentComp}
                </div>
            )}

        </div>
    );
}

export default ContentDetails;

